// BehaviorSubject semantics: late subscribers immediately receive the latest value.
export const createSubject = (initial) => {
    const listeners = new Set();
    let latest = initial;
    return {
        next(value) {
            latest = value;
            for (const fn of listeners)
                fn(value);
        },
        subscribe(next) {
            listeners.add(next);
            if (latest !== undefined)
                next(latest);
            return () => { listeners.delete(next); };
        },
        getValue() {
            return latest;
        },
    };
};
//# sourceMappingURL=observable.js.map